import React, { useState, useEffect } from 'react';
import { makeStyles, Theme, Typography } from '@material-ui/core';
import Swoosh from './swoosh';
import VideoLogo from './VideoLogo';
import TwilioLogo from './TwilioLogo';
import AccountMenu from '../AccountMenu/AccountMenu';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '../../services/firebase.config';

const useStyles = makeStyles((theme: Theme) => ({
  background: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)',
    height: '100%',
    minHeight: '100vh',
  },
  container: {
    position: 'relative',
    flex: '1',
  },
  innerContainer: {
    display: 'flex',
    width: '888px',
    minHeight: '379px',
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(44, 62, 80, 0.2)',
    overflow: 'hidden',
    position: 'relative',
    margin: 'auto',
    backgroundColor: 'white',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      height: 'auto',
      width: 'calc(100% - 40px)',
      margin: 'auto',
      maxWidth: '400px',
    },
  },
  swooshContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #2980b9 0%, #3498db 100%)',
    width: '296px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '120px',
    },
  },
  logoContainer: {
    position: 'absolute',
    width: '210px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      width: '90%',
      textAlign: 'initial',
      '& svg': {
        height: '64px',
      },
    },
  },
  twilioLogo: {
    display: 'none', // Hide Twilio logo to match our app branding
  },
  content: {
    background: 'white',
    width: '100%',
    padding: '2.5em 3.5em',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '500px',
    [theme.breakpoints.down('sm')]: {
      padding: '2em',
      minHeight: 'auto',
    },
  },
  title: {
    color: 'white',
    margin: '1em 0 0',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      fontSize: '1.1rem',
    },
  },
  account: {
    display: 'block',
    width: '500px',
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '20px',
    color: 'white',
    textAlign: 'right',
    '& a': {
      color: 'white',
      padding: '20px',
    },
  },
}));

interface IntroContainerProps {
  children: React.ReactNode;
}

const IntroContainer = (props: IntroContainerProps) => {
  const classes = useStyles();

  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const authStateListener = auth.onAuthStateChanged(user => {
      setUser(user);
    });

    return () => {
      authStateListener();
    };
  }, []);

  useEffect(() => {
    onAuthStateChanged(auth, user => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        const uid = user.uid;
        // ...
        console.log('uid', uid);
      } else {
        // User is signed out
        // ...
        console.log('user is logged out');
      }
    });
  }, []);

  return (
    <div className={classes.background}>
      <TwilioLogo className={classes.twilioLogo} />
      <AccountMenu />
      {/*{user && location.pathname !== '/login' && <UserMenu />} */}
      <div className={classes.container}>
        <div className={classes.innerContainer}>
          <div className={classes.swooshContainer}>
            <div className={classes.logoContainer}>
              <VideoLogo />
              <Typography variant="h6" className={classes.title}>
                Blue Stream
              </Typography>
            </div>
          </div>
          <div className={classes.content}>{props.children}</div>
        </div>
      </div>
    </div>
  );
};

export default IntroContainer;
